import * as angular from "angular";
import { ClickOutDirective } from "./clickOut/clickOut.directive";
import { FastScrollDirective } from "./fastScroll.directive";
import { ngMouseWheelDown } from "./ngMouseWheelDown.directive";
import { ngMouseWheelUp } from "./ngMouseWheelUp.directive";
import { ngRightClick } from "./rightClick.directive";
import { ScrollToDirective } from "./scrollTo.directive";
import { ScrollShadowDirective } from "./scrollShadow.directive";

angular
    .module("app.mouse.directives", [])

    .directive("fastScroll", FastScrollDirective.factory())
    .directive("clickOut", ClickOutDirective.factory())
    .directive("ngMouseWheelDown", ngMouseWheelDown)
    .directive("ngMouseWheelUp", ngMouseWheelUp)
    .directive("ngRightClick", ['$parse', ngRightClick])
    .directive("scrollShadow", ScrollShadowDirective.factory())
    .directive("scrollTo", ScrollToDirective.factory())
    ;
